import { IconButton } from '@fukuri-admins/ui/common/IconButton';
import { CrossIcon } from '@fukuri-admins/ui/common/Icons';
import { InputHTMLAttributes, ReactNode } from 'react';
import styles from './styles.module.scss';

type TextInputType = 'text' | 'email' | 'password' | 'number' | 'url' | 'tel';

type Props = {
  id?: string;
  type?: TextInputType;
  value?: InputHTMLAttributes<HTMLInputElement>['value'];
  defaultValue?: InputHTMLAttributes<HTMLInputElement>['defaultValue'];
  placeholder?: InputHTMLAttributes<HTMLInputElement>['placeholder'];
  onChange?: InputHTMLAttributes<HTMLInputElement>['onChange'];
  onBlur?: InputHTMLAttributes<HTMLInputElement>['onBlur'];
  inputMode?: InputHTMLAttributes<HTMLInputElement>['inputMode'];
  error?: boolean;
  /** 入力欄の先頭に表示するアイコン等のノード */
  startIcon?: ReactNode;
  /** 無効状態 */
  disabled?: boolean;
  /**
   * 入力欄末尾にクリアボタンを表示するコールバック。
   * 指定されており、かつ value が truthy のときのみクリアボタンが表示される。
   * 値を空にする責務は呼び出し側にある。
   */
  onClear?: () => void;
};

export const TextInput: React.FC<Props> = ({
  id,
  type,
  value,
  defaultValue,
  placeholder,
  onChange,
  onBlur,
  inputMode,
  error,
  startIcon,
  disabled,
  onClear,
}) => (
  <div
    className={`${styles.shell} ${error ? styles.error : ''} ${disabled ? styles.disabled : ''}`}
  >
    {startIcon && <span className={styles.startIcon}>{startIcon}</span>}
    <input
      className={styles.input}
      type={type}
      id={id}
      value={value}
      defaultValue={defaultValue}
      placeholder={placeholder}
      onChange={onChange}
      onBlur={onBlur}
      inputMode={inputMode}
      disabled={disabled}
    />
    {!!onClear && !!value && !disabled && (
      <IconButton
        variant='ghost'
        size='sm'
        icon={<CrossIcon size='xs' />}
        aria-label='入力をクリア'
        onClick={onClear}
      />
    )}
  </div>
);
